import posthog from "posthog-js";

export const CONSENT_KEY = "grassurn_analytics_consent";

const POSTHOG_KEY = "phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE";
const POSTHOG_HOST = "https://us.i.posthog.com";

let initialised = false;

export function getConsent() {
  try {
    const stored = window.localStorage.getItem(CONSENT_KEY);
    return stored === "accepted" || stored === "rejected" ? stored : null;
  } catch (err) {
    return null; // private mode or blocked storage — treat as no consent
  }
}

export function setConsent(value) {
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch (err) {
    // Storage unavailable: the choice applies for this page view only.
  }
}

// PostHog is never loaded until consent is "accepted" (audit T13). Session
// recording captures the contact form, so inputs are masked unconditionally.
export function initAnalytics() {
  if (initialised) return true;
  if (getConsent() !== "accepted") return false;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    opt_out_capturing_by_default: true,
    session_recording: { maskAllInputs: true },
  });
  posthog.opt_in_capturing();
  initialised = true;
  return true;
}

// Declining consent after a prior Accept (via Footer's "Cookie settings" →
// reopen the banner → Decline) must actually stop capturing, not just skip
// future init — the `initialised` guard above means a second initAnalytics()
// call is a no-op, so without this PostHog would keep recording for the rest
// of the page session (audit: contradicts the "change your mind at any time"
// promise in src/content/legal/privacy.js).
export function stopAnalytics() {
  if (!initialised) return;
  posthog.opt_out_capturing();
}

// Test-only: resets the module-singleton init guard between test cases.
export function __resetAnalyticsForTests() {
  initialised = false;
}
